// extracted by mini-css-extract-plugin
module.exports = {"div-2":"EquityDisplay_div-2__qr0JT"};